export const Info = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#4896D7" />
      <path d="M11.8195 10C12.4375 10 12.9075 10.5549 12.8059 11.1644L12 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H11.1805C10.5625 18 10.0925 17.4451 10.1941 16.8356L11 12H10C9.44772 12 9 11.5523 9 11C9 10.4477 9.44772 10 10 10H11.8195Z" fill="white" />
      <path d="M12.5 9C13.3284 9 14 8.32843 14 7.5C14 6.67157 13.3284 6 12.5 6C11.6716 6 11 6.67157 11 7.5C11 8.32843 11.6716 9 12.5 9Z" fill="white" />
    </svg>
  )
}

